// import Vue from 'vue';
import router from '../router';
// Vuex Store
import store from '../store/store';
import _axios from 'axios';

const axios = _axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 35000, // indicates, 1000ms ie. 1 second
  headers: {
    'Content-Type': 'application/json',
  },
});

const fallbackAxios = _axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 35000, // indicates, 1000ms ie. 1 second
  headers: {
    'Content-Type': 'application/json',
  },
});

const debugConsole = false;
const apiDomain = process.env.VUE_APP_LOCAL_ENV ? process.env.VUE_APP_API_DOMAIN_LOCAL
  : process.env.VUE_APP_STAGING_ENV ? process.env.VUE_APP_API_DOMAIN_TESTING
  : process.env.VUE_APP_UAT_ENV ? process.env.VUE_APP_API_DOMAIN_UAT
  : process.env.VUE_APP_API_DOMAIN;

axios.interceptors.request.use(
  (config) => {
    if (store.state.activeUser != null && store.state.activeUser.userToken) {
      config.headers.Authorization =
        'Bearer ' + store.state.activeUser.userToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    // Return a successful response back to the calling service
    return response;
  },
  (error) => {
    // Return any error which is not due to authentication back to the calling service
    if (error.response.status !== 401) {
      return Promise.reject(error);
    }

    // Logout user if token refresh didn't work or user is disabled
    if (
      error.config.url.indexOf('/v1/oauth/token') > 0 ||
      !store.state.activeUser.refreshToken
    ) {
      store.commit('LOGOUT_USER_ACCOUNT');
      router.push('/login');

      return Promise.reject(error);
    }
    // Try request again with new token
    let url = `${apiDomain}/v1/oauth/token`;
    // const data    = {
    //   client_id: store.state.activeUser.clientId,
    //   grant_type: 'refresh_token',
    //   refresh_token: store.state.activeUser.refreshToken
    // };

    const params = new URLSearchParams();
    params.append('client_id', store.state.activeUser.clientId);
    params.append('grant_type', 'refresh_token');
    params.append('refresh_token', store.state.activeUser.refreshToken);
    params.append('otp_key', store.state.otpKey);
    params.append('otp', store.state.otpValue);

    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };

    return fallbackAxios
      .post(url, params, { headers })
      .then((result) => {
        if (debugConsole)
          console.warn(
            'fallback Axios for refreshToken oauth refresh succeeded',
            result.data
          );

        // Save user token
        let userAccount = {
          // firstName: '',
          // lastName: '',
          // country: '',
          // mobile: '',
          // email: '',
          userToken: result.data.access_token,
          refreshToken: result.data.refresh_token,
        };
        store.commit('LOGIN_USER_ACCOUNT', userAccount);

        // New request with new token (retry the request that failed due to expired user token)
        const config = error.config;

        config.headers['Authorization'] = `Bearer ${result.data.access_token}`;

        return axios.request(config);
      })
      .catch((error) => {
        store.commit('LOGOUT_USER_ACCOUNT');
        router.push('/login');

        return Promise.reject(error);
      });
  }
);

export default axios;
